import { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'react-toastify';
import * as Sentry from '@sentry/react';

const PaidToSellerInputPage = () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();

    const [selectedMonth, setSelectedMonth] = useState(currentMonth);
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [amount, setAmount] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const { apiFetch } = useAuth();

    const months = [
        { value: 1, name: "January" }, { value: 2, name: "February" }, { value: 3, name: "March" },
        { value: 4, name: "April" }, { value: 5, name: "May" }, { value: 6, name: "June" },
        { value: 7, name: "July" }, { value: 8, name: "August" }, { value: 9, name: "September" },
        { value: 10, name: "October" }, { value: 11, name: "November" }, { value: 12, name: "December" }
    ];
    const years = [currentYear, 2024];

    const isMonthDisabled = (monthValue) => {
        if (selectedYear > currentYear) return false;
        if (selectedYear === currentYear && monthValue > currentMonth) return true;
        return false;
    };

    const getSelectedPeriod = () =>
        `${selectedYear}${selectedMonth.toString().padStart(2, '0')}`;

    // Fetch value for selected period
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await apiFetch(`/api/Leasing/ByPeriod?period=${getSelectedPeriod()}`);
                const data = await response.json();
                if (data.success && data.data !== null && data.data !== undefined) {
                    setAmount(data.data.toString());
                } else {
                    setAmount('');
                }
            } catch (catchError) {
                Sentry.captureException(catchError);
                setAmount('');
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
        // eslint-disable-next-line
    }, [selectedMonth, selectedYear]);

    const handleInputChange = (e) => {
        const value = e.target.value;
        if (value === '' || /^\d+(\.\d{0,2})?$/.test(value)) {
            setAmount(value);
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const payload = {
                Period: getSelectedPeriod(),
                Value: parseFloat(amount) || 0
            };
            const response = await apiFetch('/api/Leasing', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (data.success) {
                toast.success('Data saved successfully!');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="paid-to-seller-container">
            <h1>Paid To Seller Input</h1>
            <div className="period-selector">
                <label>Month:</label>
                <select value={selectedMonth} onChange={e => setSelectedMonth(Number(e.target.value))}>
                    {months.map(month => (
                        <option key={month.value} value={month.value} disabled={isMonthDisabled(month.value)}>
                            {month.name}
                        </option>
                    ))}
                </select>
                <label>Year:</label>
                <select value={selectedYear} onChange={e => setSelectedYear(Number(e.target.value))}>
                    {years.map(year => (
                        <option key={year} value={year}>{year}</option>
                    ))}
                </select>
            </div>
            <form onSubmit={handleSave}>
                <div
                    style={{ paddingBottom: '10px' }}
                >
                    <label>Paid To Seller Amount</label>
                    <input
                        type="text"
                        name="PaidToSellerAmount"
                        value={amount}
                        onChange={handleInputChange}
                        inputMode="decimal"
                        placeholder="Enter amount"
                    />
                </div>
                <button type="submit" disabled={isLoading}>
                    {isLoading ? 'Saving...' : 'Save'}
                </button>
            </form>
</div>
    );
};

export default PaidToSellerInputPage;